<template>
  <div class="table-container">
    <table class="content-table">
      <thead class="header-table">
      <tr class="trhead">
        <th class="test-name-column">{{$t('reports.test_name')}}</th>
        <th class="status-column">{{$t('status_payment')}}
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.22586 2.35999L2.36584 0.5L0.505859 2.35999" stroke="#292D32" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path d="M2.36523 9.5V0.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.77539 7.64014L7.63541 9.50012L9.49539 7.64014" stroke="#292D32" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path d="M7.63672 0.5V9.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </th>
        <th class="question-count-column">{{$t('reports.number_of_questions')}}
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.22586 2.35999L2.36584 0.5L0.505859 2.35999" stroke="#292D32" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path d="M2.36523 9.5V0.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.77539 7.64014L7.63541 9.50012L9.49539 7.64014" stroke="#292D32" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path d="M7.63672 0.5V9.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </th>
        <th class="completion-column">{{$t('reports.completion')}}
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.22586 2.35999L2.36584 0.5L0.505859 2.35999" stroke="#292D32" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path d="M2.36523 9.5V0.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.77539 7.64014L7.63541 9.50012L9.49539 7.64014" stroke="#292D32" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path d="M7.63672 0.5V9.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </th>
        <th class="creation-date-column">{{$t('reports.creation')}}
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.22586 2.35999L2.36584 0.5L0.505859 2.35999" stroke="#292D32" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path d="M2.36523 9.5V0.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.77539 7.64014L7.63541 9.50012L9.49539 7.64014" stroke="#292D32" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path d="M7.63672 0.5V9.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </th>
        <th class="creator-column">{{$t('reports.creator')}}</th>
      </tr>
      </thead>
      <tbody class="tbody-container">
      <tr class="tr-class" v-if="loading">
        <td colspan="6" class="table-loading">
        </td>
      </tr>

      <tr v-else-if="!loading && tests.length === 0" class="tr-class">
        <td colspan="6" class="table-loading">
          <span class="text">{{$t('no_data_found')}}</span>
        </td>
      </tr>

      <tr class="tr-class" v-else v-for="test in tests" :key="test.testId">
        <td class="td-style test-name-cell">
          <div class="test-name-content">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M10.7996 12H1.19961C1.04048 12 0.887867 11.9368 0.775345 11.8243C0.662823 11.7117 0.599609 11.5591 0.599609 11.4V0.6C0.599609 0.44087 0.662823 0.288258 0.775345 0.175736C0.887867 0.0632141 1.04048 0 1.19961 0H10.7996C10.9587 0 11.1114 0.0632141 11.2239 0.175736C11.3364 0.288258 11.3996 0.44087 11.3996 0.6V11.4C11.3996 11.5591 11.3364 11.7117 11.2239 11.8243C11.1114 11.9368 10.9587 12 10.7996 12ZM10.1996 10.8V1.2H1.79961V10.8H10.1996ZM3.59961 3H8.39961V4.2H3.59961V3ZM3.59961 5.4H8.39961V6.6H3.59961V5.4ZM3.59961 7.8H6.59961V9H3.59961V7.8Z"
                  fill="#344054"/>
            </svg>
            <span class="test-name" :title="test.name">
                {{ truncateText(test.name, 35) }}
              </span>
          </div>
        </td>

        <td class="td-style status-cell">
            <span class="status-badge" :class="test.isPublish ? 'active' : 'draft'">
              <span class="status-dot"></span>
              <span v-if="test.isPublish">{{$t('published')}}</span>
              <span v-else>{{$t('draft')}}</span>
            </span>
        </td>

        <td class="td-style question-count-cell">
          <span class="question-count">{{ test.questionsCount || 0 }} {{$t('questions_subtitle')}}</span>
        </td>

        <td class="td-style completion-cell">
          <div class="completion-wrapper">
            <div class="progress-container">
              <div class="progress-bar">
                <div class="progress-fill"
                     :class="{
                         'low': test.progress < 30,
                         'medium': test.progress >= 30 && test.progress < 70,
                         'high': test.progress >= 70
                       }"
                     :style="{ width: test.progress + '%' }"></div>
              </div>
              <span class="progress-text">{{ test.progress || 0 }}%</span>
            </div>
          </div>
        </td>

        <td class="td-style creation-date-cell">
          <span class="creation-date">{{ formatDate(test.created_at) }}</span>
        </td>

        <td class="td-style creator-cell">
          <div class="creator-info">
            <template v-if="test.created_By?.fullName">
              <span class="creator-initials">{{ getInitials(test.created_By.fullName) }}</span>
              <span class="creator-name" :title="test.created_By.fullName">
                  {{ truncateText(test.created_By.fullName, 15) }}
                </span>
            </template>
            <template v-else>
              <span class="creator-initials">N/A</span>
              <span class="creator-name"></span>
            </template>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {ref, onMounted, defineExpose, computed, watch} from 'vue';
import { useI18n } from 'vue-i18n';

export default {
  name: 'TestFeaturesTable',
  props: {
    fetchTests: {
      type: Function,
      required: true
    },
    tests: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { locale } = useI18n();
    const selectAll = ref(false);
    const selectedTestIds = ref([]);
    const displayTests = computed(() => props.tests);

    const localeMap = {
      'tr': 'tr-TR',
      'en': 'en-US'
    };

    watch(() => props.tests, (newTests) => {
      selectedTestIds.value = [];
      selectAll.value = false;
    }, { deep: true, immediate: true });

    const toggleAll = () => {
      if (selectAll.value) {
        selectedTestIds.value = displayTests.value.map(test => test.testId);
      } else {
        selectedTestIds.value = [];
      }
    };

    const toggleTest = (e, testId) => {
      if (e.target.checked) {
        selectedTestIds.value.push(testId);
      } else {
        selectedTestIds.value = selectedTestIds.value.filter(id => id !== testId);
      }
    };

    const truncateText = (text, length) => {
      if (!text) return '';
      return text.length > length ? text.slice(0, length) + '...' : text;
    };

    const formatDate = (dateString) => {
      if (!dateString) return 'N/A';
      const currentLocale = localeMap[locale.value] || 'tr-TR';
      let date;

      if (dateString.includes('.')) {
        const dateOnly = dateString.split(' ')[0];
        const parts = dateOnly.split('.');
        if (parts.length === 3) {
          date = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
        }
      } else {
        date = new Date(dateString);
      }

      if (!date || isNaN(date.getTime())) return 'N/A';

      return date.toLocaleDateString(currentLocale, {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
      });
    };

    const getInitials = (fullName) => {
      if (!fullName) return 'NA';
      return fullName
          .split(' ')
          .map(name => name.charAt(0))
          .join('')
          .toUpperCase()
          .slice(0, 2);
    };

    const filterData = async (filters) => {
      let status = 'all';
      if (filters.status === 'active') {
        status = 1;
      } else if (filters.status === 'draft') {
        status = 0;
      }

      if (props.fetchTests && typeof props.fetchTests === 'function') {
        await props.fetchTests(status);
      }
    };

    const refreshData = async (status = 'all') => {
      if (props.fetchTests && typeof props.fetchTests === 'function') {
        await props.fetchTests(status);
      }
    };

    onMounted(async () => {
      if (props.fetchTests && typeof props.fetchTests === 'function') {
        await props.fetchTests('all');
      }
    });

    defineExpose({
      filterData,
      refreshData
    });

    return {
      selectAll,
      selectedTestIds,
      tests: displayTests,
      toggleAll,
      toggleTest,
      truncateText,
      formatDate,
      getInitials,
      filterData,
      refreshData
    };
  }
}
</script>

<style scoped>
.test-name-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.test-name {
  font-weight: 500;
  color: #101828;
  line-height: 20px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.status-badge.active .status-dot {
  background: #3da33e;
}

.status-badge.draft .status-dot {
  background: #f09460;
}

.question-count {
  color: #475467;
  font-size: 14px;
  font-weight: 400;
}

.completion-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.progress-container {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.progress-bar {
  flex: 1;
  height: 8px;
  background: #F2F4F7;
  border-radius: 4px;
  overflow: hidden;
  max-width: 120px;
}

.progress-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.progress-fill.low {
  background: #12B76A;
}

.progress-fill.medium {
  background: #12B76A;
}

.progress-fill.high {
  background: #12B76A;
}

.progress-text {
  font-size: 14px;
  font-weight: 500;
  color: #475467;
  min-width: 35px;
}

.creation-date {
  color: #475467;
  font-size: 14px;
  font-weight: 400;
}

.creator-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.creator-initials {
  width: 24px;
  height: 24px;
  background: #f2f4f7;
  color: black;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  flex-shrink: 0;
}

.creator-initials.na {
  background: #98A2B3;
}

.creator-name {
  color: #475467;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #F2F4F7;
  border-top: 2px solid #667085;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.table-loading {
  text-align: center;
  padding: 40px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.table-loading .text {
  color: #667085;
  font-size: 14px;
  font-weight: 400;
}

.test-name-column {
  width: 30%;
  min-width: 200px;
}

.status-column {
  width: 12%;
  min-width: 100px;
}

.question-count-column {
  width: 12%;
  min-width: 100px;
}

.completion-column {
  width: 18%;
  min-width: 140px;
}

.creation-date-column {
  width: 14%;
  min-width: 120px;
}

.creator-column {
  width: 14%;
  min-width: 120px;
}

@media (max-width: 768px) {
  .test-name-content {
    gap: 8px;
  }

  .progress-container {
    gap: 8px;
  }

  .progress-bar {
    max-width: 80px;
  }
}
</style>
